import type { Site } from '@/api/fe-api/domain/entities/site';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { formatDate } from '@/utils/format/date';

export type TableTrippedSystemsProps = {
  site: Site;
};

export function TableTrippedSystems({ site }: TableTrippedSystemsProps) {
  return (
    <Table className="table-fixed">
      <TableHead>
        <TableRow>
          <TableHeader>&nbsp;</TableHeader>
          <TableHeader>ID</TableHeader>
          <TableHeader>Tripped since</TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {site.unitStatus.tripped.map((unit, index) => (
          <TableRow key={`${unit.frontendId}/${formatDate(unit.since)}`}>
            <TableCell className="text-zinc-400">{index + 1}</TableCell>
            <TableCell>{unit.frontendId}</TableCell>
            <TableCell>{formatDate(unit.since)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
